export default "__VITE_ASSET__BwUqQ2Zl__"